<section class="vm-articlelist vm-row" [id]="data?.id">
  <h2 class="vm-articlelist__header" *ngIf="data?.title">
    {{ data?.title }}
  </h2>
  <vm-markdown *ngIf="data?.copy" [data]="data?.copy" class="vm-articlelist__copy"></vm-markdown>
  <div class="vm-articlelist__list" *ngFor="let item of data?.items; last as isLast">
    <div class="vm-article vm-article--large">
      <figure class="vm-article__image-wrapper">
        <img src="{{ item?.image }}" alt="{{ item?.iconAlt }}" loading="lazy" />
      </figure>
      <div class="vm-article__text">
        <h2>{{ item?.title }}</h2>
        <vm-markdown *ngIf="item?.copy" [data]="item?.copy"></vm-markdown>
      </div>
    </div>
    <vm-divider-line *ngIf="!isLast"></vm-divider-line>
  </div>
</section>
